import React from 'react';
import styled from 'styled-components';
import { Badge } from '../shared/Badge';
import { derivePageChips } from '../../utils/pageChips';
import type { CanvasPage } from './DocumentCanvasPanel';

const Strip = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding: 4px 0;
    font-size: 11px;
    color: #555;
    min-height: 22px;
`;

export interface PageMetaStripProps {
    page: CanvasPage | null | undefined;
}

export const PageMetaStrip: React.FC<PageMetaStripProps> = ({ page }) => {
    const chips = derivePageChips(page);
    if (chips.length === 0) return null;
    return (
        <Strip role="group" aria-label="Page metadata">
            {chips.map(chip => (
                <Badge
                    key={chip.key}
                    label={chip.label}
                    type={chip.type}
                    title={chip.title}
                />
            ))}
        </Strip>
    );
};
